import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import getErrorMessage from '../../utils/getErrorMessage';

const initialState = {
  isLoading: true,
  data: [],
  filters: {
    startdate: null,
    enddate: null,
    locationid: '',
    userid: '',
    companyid: '',
    productid: '',
  },
  error: '',
};

export const fetchHarvestProductivity = createAsyncThunk(
  'harvestProductivity/fetchHarvestProductivity',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/harvests/picker-performance`, {
        params: { ...params },
      });

      return response.data;
    } catch (err) {
      const code = err?.errors ? err.errors[0]?.code : null;
      const message = getErrorMessage(code);
      return rejectWithValue(message);
    }
  }
);

const harvestProductivitySlice = createSlice({
  name: 'harvestProductivitySlice',
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = {
        ...state.filters,
        locationid: '',
        userid: '',
        companyid: '',
        productid: '',
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchHarvestProductivity.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHarvestProductivity.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = '';
      state.data = payload.data;
    });
    builder.addCase(fetchHarvestProductivity.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });
  },
});

export const { setData, setFilters, resetFilters } = harvestProductivitySlice.actions;

export default harvestProductivitySlice.reducer;

export const selectHarvestProductivityFilters = (state) => state.harvestProductivity.filters;
export const selectHarvestProductivityData = (state) => state.harvestProductivity.data;
export const selectHarvestProductivityLoading = (state) => state.harvestProductivity.isLoading;
export const selectHarvestProductivityError = (state) => state.harvestProductivity.error;
